module.exports = __webpack_public_path__ + "static/blog-img14-870eb9c7c281eb9a1ff1a6132f28d0ae.jpg";